/**
 * Utility functions for authentication checks
 */

/**
 * Check if there's any evidence of authentication locally
 * This includes localStorage tokens and authentication cookies
 * @returns {boolean} True if there's potential evidence of authentication
 */
export const hasLocalAuthEvidence = () => {
  // Check localStorage for token
  const storedToken = localStorage.getItem('token');
  const storedUser = localStorage.getItem('user');
  
  if (storedToken && storedUser) {
    return true;
  }
  
  // Check for authentication cookies
  return hasAuthCookies();
};

/**
 * Check if authentication cookies are present
 * @returns {boolean} True if authentication cookies exist
 */
export const hasAuthCookies = () => {
  // Check for the JWT cookie (gobag_token)
  const hasJWTCookie = document.cookie
    .split(';')
    .some(cookie => cookie.trim().startsWith('gobag_token='));
  
  // Check for session cookies (common session cookie names)
  const hasSessionCookie = document.cookie
    .split(';')
    .some(cookie => {
      const name = cookie.trim().split('=')[0];
      return name === 'session' || name.startsWith('flask-session') || name.includes('session');
    });
  
  return hasJWTCookie || hasSessionCookie;
};

/**
 * Check if the stored token appears to be a real JWT token
 * (not the placeholder 'authenticated_via_cookie' value)
 * @returns {boolean} True if stored token is a real JWT
 */
export const hasValidStoredToken = () => {
  const storedToken = localStorage.getItem('token');
  return !!(storedToken && 
            storedToken !== 'authenticated_via_cookie' && 
            storedToken.includes('.')); // JWT tokens have dots
};